module.exports = __webpack_public_path__ + "img/FI20086972.27d9e9ab.svg";